import { render, staticRenderFns } from "./ViewDataIndex.vue?vue&type=template&id=ab83d09c&scoped=true&"
import script from "./ViewDataIndex.vue?vue&type=script&lang=js&"
export * from "./ViewDataIndex.vue?vue&type=script&lang=js&"
import style0 from "./ViewDataIndex.vue?vue&type=style&index=0&id=ab83d09c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab83d09c",
  null
  
)

export default component.exports